// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as JsxRuntime from "react/jsx-runtime";

let defaultPrice = "0,000";

let defaultCurrency = I18n.toCurrencySymbol("EUR");

function ProductPriceTableCell(props) {
  let __size = props.size;
  let value = props.value;
  let size = __size !== undefined ? __size : "normal";
  if (value !== undefined) {
    return JsxRuntime.jsx(TextStyle.make, {
      children: value.replace(".", ","),
      size: size,
      lineHeight: "xsmall"
    });
  } else {
    return JsxRuntime.jsx(TextStyle.make, {
      children: defaultPrice + ` ` + defaultCurrency,
      variation: "normal",
      size: size
    });
  }
}

let make = React.memo(ProductPriceTableCell);

export {
  defaultPrice,
  defaultCurrency,
  make,
}
/* defaultCurrency Not a pure module */
